import {Divider, Typography, Box} from '@mui/material';
import {AppIconButton} from 'components/buttons';
import {AppMenu} from 'components/menus';
import {CiViewColumn} from 'react-icons/ci';
import {AppButton} from 'components/buttons/AppButton';
import {AppSwitch} from 'components/form';
import {Column} from '@tanstack/react-table';
import {AppTooltip} from 'components/toolip';

interface AppTableColumnVisibilityToggleMenuProps<TData> {
    columns: Column<TData, unknown>[];
}

export const AppTableColumnVisibilityToggleMenu = <TData,>({
    columns,
}: AppTableColumnVisibilityToggleMenuProps<TData>) => {
    const handleShowAll = () => {
        columns.forEach(col => col.toggleVisibility(true));
    };
    const handleHideAll = () => {
        columns.forEach(col => col.toggleVisibility(false));
    };
    return (
        <>
            <AppMenu
                menuItems={[]}
                icon={onClick => (
                    <AppTooltip title="Column Visibility">
                        <AppIconButton onClick={onClick} size="large">
                            <CiViewColumn />
                        </AppIconButton>
                    </AppTooltip>
                )}
                preCustomMenu={
                    <>
                        <Box px={2} pt={1} pb={0.5} display="flex" alignItems="center" justifyContent="space-between">
                            <Typography
                                variant="subtitle2"
                                fontWeight={700}
                                sx={{letterSpacing: 1, mr: 1, color: 'primary.main'}}
                            >
                                Column Visibility
                            </Typography>
                            <Box display="flex" gap={0.5}>
                                <AppButton size="small" variant="outlined" color="primary" onClick={handleShowAll}>
                                    Show all
                                </AppButton>
                                <AppButton size="small" variant="contained" color="secondary" onClick={handleHideAll}>
                                    Hide all
                                </AppButton>
                            </Box>
                        </Box>
                        <Divider sx={{mt: 1}} />
                        {columns.map(col => (
                            <Box
                                key={col.id}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    px: 2,
                                }}
                            >
                                <AppSwitch
                                    size="small"
                                    checked={col.getIsVisible()}
                                    onChange={col.getToggleVisibilityHandler()}
                                    color="primary"
                                    label={
                                        typeof col.columnDef.header === 'string' ? col.columnDef.header : 'NO Header'
                                    }
                                />
                            </Box>
                        ))}
                    </>
                }
            />
        </>
    );
};
